<h1 class="text-white text-lg font-semibold mb-4">Gestión de Flota</h1>
<div class="mb-4 flex justify-between items-center">
    <button matButton (click)="onCreateBus()" *ngIf="canCreateBus$ | async">Crear Nuevo Bus</button>
    <mat-form-field class="ml-4 border-0">
        <input matInput (input)="applyFilter($event)" placeholder="Buscar...">
    </mat-form-field>
</div>
<div *ngIf="dataSource.data.length === 0" class="text-center py-8 text-gray-500">
    <p>No hay flota registrada.</p>
</div>
<div class="mat-elevation-z2">
    <table mat-table [dataSource]="dataSource" matSort class="w-full">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Número </th>
            <td mat-cell *matCellDef="let bus"> {{ bus.name }} </td>
        </ng-container>
        <ng-container matColumnDef="licensePlate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Placas </th>
            <td mat-cell *matCellDef="let bus"> {{ bus.licensePlate }} </td>
        </ng-container>
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Activo </th>
            <td mat-cell *matCellDef="let bus"> {{ bus.status ? 'Sí' : 'No' }} </td>
        </ng-container>
        <ng-container matColumnDef="partnerName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Cliente </th>
            <td mat-cell *matCellDef="let bus"> {{ bus.partnerName }} </td>
        </ng-container>
        <ng-container matColumnDef="routeName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Ruta </th>
            <td mat-cell *matCellDef="let bus"> {{ bus.routeName }} </td>
        </ng-container>
        <ng-container matColumnDef="entityName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Entidad </th>
            <td mat-cell *matCellDef="let bus"> {{ bus.entityName }} </td>
        </ng-container>
        <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Creado </th>
            <td mat-cell *matCellDef="let bus">{{ bus.createdAt | date:'dd-MM-yyyy, hh:mm:ss a' }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Acciones </th>
            <td mat-cell *matCellDef="let bus">
                <button mat-icon-button color="accent" aria-label="Editar bus" (click)="onEditBus(bus)" *ngIf="canEditBus$ | async">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" aria-label="Eliminar bus" (click)="onDeleteBus(bus.id)" *ngIf="canDeleteBus$ | async">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Seleccionar página de flota"></mat-paginator>
</div>